import da_DK from "~/i18n/locales/da_DK.json";
import en_US from "~/i18n/locales/en_US.json";

export default defineI18nConfig(() => ({
  legacy: false,
  locale: "en_US",
  fallbackLocale: "en_US",
  messages: {
    da_DK,
    en_US,
  },
}));
